export function formatNumber(value, decimal, locale) {
  if (value === null || value === undefined) return value;
  const currentLocale = locale || navigator.language;
  let options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 16,
    numberingSystem: "latn" // to represent the number value always as a number format. Refer KF4-4436
  };
  if (!["", null, undefined, NaN].includes(decimal)) {
    options = {
      ...options,
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal
    };
  }
  return new Intl.NumberFormat(currentLocale, options).format(value);
}

export function formatNumberToParts(value, decimal, locale) {
  if (!value) return value;
  const currentLocale = locale || navigator.language;
  let options = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 16,
    numberingSystem: "latn" // to represent the number value always as a number format. Refer KF4-4436
  };
  if (!["", null, undefined, NaN].includes(decimal)) {
    options = {
      ...options,
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal
    };
  }
  return new Intl.NumberFormat(currentLocale, options).formatToParts(value);
}
